import React from 'react'

export default function LevelSummaries({ rows, eventContext, t }) {
  const decimal = value => Number.isFinite(value) ? value.toFixed(1) : '—'
  return <section aria-label={t(eventContext ? 'assessmentByLevel' : 'receivedLevels')} className="mb-4">
    <h5>{t(eventContext ? 'assessmentByLevel' : 'levelByContext')}</h5>
    <div className="table-responsive"><table className="table table-sm"><thead><tr>
      <th>{t(eventContext ? 'competitionLevel' : 'sportFormat')}</th><th>{t(eventContext ? 'averageAssessed' : 'currentLevel')}</th>
      <th>{t(eventContext ? 'difference' : 'averageAssessed')}</th><th>{t('numericAnswers')}</th>
    </tr></thead><tbody>{rows.map((row, index) => <tr key={index}>
      <td>{eventContext && <strong>{row.competitionLevel != null ? t('levelValue', { value: row.competitionLevel }) : '—'}</strong>}<span className="d-block">{t(row.sportType)} · {t(row.gameType)}</span></td>
      <td>{eventContext ? decimal(row.average) : row.currentLevel ?? '—'}</td>
      <td>{eventContext ? Number.isFinite(row.difference) ? (row.difference > 0 ? '+' : '') + decimal(row.difference) : '—' : decimal(row.average)}</td>
      <td>{row.numericCount}<small className="d-block text-muted">{t('cannotAssessCount', { count: row.cannotAssessCount })}{eventContext && ' · ' + t('excludedCount', { count: row.excludedCount })}</small></td>
    </tr>)}</tbody></table></div>
  </section>
}
